:host {
  display: block;
  margin-top: $size-space-xs !important;
  margin-bottom: $size-space-xs !important;
  pointer-events: none;
}

.smart-features-list-item {
  display: flex;
  align-items: center;
  flex-grow: 1;

  width: 100%;

  smart-text {
    margin-left: 10px;
    &:first-letter {
      text-transform: capitalize;
    }
  }

  &--checked {
    smart-text {
      color: var(--smart-features-list-item-checked-text-color) !important;
    }
  }
  &--unchecked {
    smart-text{
      color: var(--smart-features-list-item-unchecked-text-color) !important;
      text-decoration: line-through !important;
    }
  }
}